// extracted by mini-css-extract-plugin
export default {"pulsatingDotForCopyStyles":"ohBB3fodJM_ISZaSSqcB"};